<template>
  <div class="ws-participants-details">
    <popper
      trigger="hover"
      v-if="participant.noc_document"
      :options="{placement: 'top'}">
      <div class="popper is-warning has-text-left exam-status-hint">
        <strong>{{$t('Документ:')}}</strong>&nbsp;{{participant.noc_document.name}}<br>
        <strong>{{$t('Номер:')}}</strong>&nbsp;{{participant.noc_document.number}}<br>
        <strong>{{$t('Дата выдачи:')}}</strong>&nbsp;<ws-time-formatter :date="participant.noc_document.issued_at"></ws-time-formatter>
      </div>
      <div class="tag is-link" slot="reference">
        {{$t('exam.flags.independent_estimate')}}
      </div>
    </popper>
    <dl class="ws-participants-details__docs" v-if="isNoc">
      <dt>
        <span class="is-size-5">{{ $t('Заявление НОК ')}}<a :href="patternLink" target="_blank">{{$t('(шаблон)')}}</a>{{ $t(':')}}</span>
      </dt>
      <dd v-if="files[NOC_FILE_CATEGORY] && files[NOC_FILE_CATEGORY].length">
        <span class="has-text-success has-text-weight-bold">{{ $t('Загружен')}} </span>
        <ws-role-node :only="['front_rcc', 'front_dep', 'front_admin']">
          <file-download class="is-size-5 is-inline-block" :file="files[NOC_FILE_CATEGORY][0]" :isShowFileDate="false" :buttonLabel="''" @remove="removeFile(NOC_FILE_CATEGORY)" />
        </ws-role-node>
        <ws-role-node :except="['front_rcc', 'front_dep', 'front_admin']">
          <file-download class="is-size-5 is-inline-block remove-disabled" :isShowFileDate="false" :file="files[NOC_FILE_CATEGORY][0]" :buttonLabel="''" />
        </ws-role-node>
      </dd>
      <dd v-else>
        <span class="has-text-danger has-text-weight-bold">{{ $t('Не загружен')}}&nbsp;</span>
        <ws-role-node :only="['front_rcc', 'front_dep', 'front_admin']">
          <file-upload class="is-inline-block" :category="NOC_FILE_CATEGORY" :item-guid="participant.guid" @uploaded="onUploadFile" :buttonLabel="$t('Загрузить')" accept="application/pdf"/>
        </ws-role-node>
      </dd>
    </dl>
<!--    <div>-->
<!--      <b-checkbox-->
<!--        name="independent_estimate"-->
<!--        @input="onNocChanged"-->
<!--        :disabled="!isCanChange"-->
<!--        v-model="newItem.noc">-->
<!--        <b>{{ $t('flags.independent_estimate')}}</b>-->
<!--      </b-checkbox>-->
<!--    </div>-->
    <b-loading :active="isLoading" :is-full-page="false"></b-loading>
  </div>
</template>

<script>
import { constants } from '@/services/constants.service'
import { mapActions } from 'vuex'
import Popper from 'vue-popperjs'
const nullGuid = '00000000-0000-0000-0000-000000000000'
const NOC_FILE_CATEGORY = 'de-participants-noc'
export default {
  name: 'WsExamGroupsParticipantsDetails',
  components: { 'popper': Popper },
  props: {
    participant: Object,
    exam: Object
  },
  data: function () {
    return {
      files: {
        [NOC_FILE_CATEGORY]: []
      },
      isLoading: false,
      newItem: {},
      constants,
      NOC_FILE_CATEGORY,
      patternLink: 'https://worldskills.ru/nashi-proektyi/demonstraczionnyij-ekzamen/vzaimodejstvie-s-spk/vzaimodejstvie-s-spk.html'
    }
  },
  watch: {
    participant: {
      handler (value) {
        if (value) {
          this.newItem = Object.assign({}, value)
        }
      },
      immediate: true
    }
  },
  computed: {
    isNoc () {
      return this.exam.flags.indexOf('independent_estimate') > -1
    }
  },
  methods: {
    ...mapActions('profile/files', {
      getFileByRecId: 'getFileByRecId',
      removeFileByRecId: 'removeFileByRecId'
    }),
    async getFile (category) {
      this.isLoading = true
      const files = await this.getFileByRecId({
        'rec-guid': this.newItem.guid,
        'category': this.NOC_FILE_CATEGORY
      })
      this.files[category] = files
      this.isLoading = false
    },
    async removeFile (category) {
      const file = this.files[category][0]
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить файл ${file.file_name}?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          try {
            this.isLoading = true
            await this.removeFileByRecId({
              'rec-guid': this.newItem.guid,
              category,
              'file-guid': file.guid
            })
            await this.getFile(this.NOC_FILE_CATEGORY)
            this.newItem.files[NOC_FILE_CATEGORY].guid = constants.NULL_GUID
            this.$emit('file-updated', this.newItem)
          } catch (e) {
            console.log(e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    async onUploadFile () {
      await this.getFile(this.NOC_FILE_CATEGORY)
      this.newItem.files[NOC_FILE_CATEGORY] = this.files[this.NOC_FILE_CATEGORY][0]
      this.$emit('file-updated', this.newItem)
    },
    onNocChanged () {
      this.$emit('updated', this.newItem)
    }
  },
  async mounted () {
    if (
      this.participant.files &&
      this.participant.files[this.NOC_FILE_CATEGORY] &&
      this.participant.files[this.NOC_FILE_CATEGORY].guid !== nullGuid
    ) {
      this.files[this.NOC_FILE_CATEGORY].push(this.participant.files[this.NOC_FILE_CATEGORY])
    }
  }
}
</script>
